import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/er404'
import Editor from './views/Editor.vue'
import Admin from './views/PainelAdmin.vue'
import Login from './views/Login.vue'
import LinkUnico from './views/LinkUnico.vue'
import Paginas from './views/Paginas.vue'
import VerPagina from './views/VerPagina.vue'

//*importar firebase para autenticação de rotas
import { auth } from './firebase'

Vue.use(Router)

//* Configuração das rotas
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/editor',
      name: 'editor',
      component: Editor,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresGuest: true }
    },
    {
      path: '/link',
      name: 'linkUnico',
      component: LinkUnico
    },
    {
      path: '/paginas',
      name: 'paginas',
      component: Paginas,
      meta: { requiresAuth: true }
    },
    {
      path:'/pageview',
      name: 'verPagina',
      component: VerPagina
    },
    //* Caso não exista a página
    { path: '/404', component: NotFound },
    { path: '/', redirect: '/admin' },  
    { path: '*', redirect: '/404' },  
  ]
})

auth.onAuthStateChanged((user) => {
    if (!user && record.meta.requiresAuth == true) {
    	router.replace('/login'); 
    } else{
    }
});

//* Validação da route
router.beforeEach((to, from, next) => {
  const currentUser = auth.currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresGuest = to.matched.some(record => record.meta.requiresGuest)

  auth.onAuthStateChanged((user) => {
		if (requiresAuth && !user) {
			next('/login')
		} else if(requiresGuest && user) {
      next('/admin')
    } else{
			next()
		}
	});
})

export default router